import { TeamMember } from '.';

export enum FormFieldTypes {
  text = 'text',
  longText = 'longText',
  date = 'date',
  singleSelection = 'singleSelection',
  multipleSelection = 'multipleSelection',
  number = 'number',
  separator = 'separator',
  signature = 'signature',
}

export interface FormFiled {
  id: string | number;
  type: FormFieldTypes;
  requiredForInitiation: boolean;
  orderNumber: number;
  whoCanView: string[];
  whoCanAnswer?: string[];
  title?: string;
  description?: string; // StringifiedJSON or StringifiedHTML,
  options?: { title: string; orderNumber: number }[];
}

export interface FormFeature {
  id: number;
  name: string;
  description: string;
  typeKey: string;
  canBeDisabled: boolean;
}

export interface Form {
  id?: number;
  name: string;
  features: {
    featureTypeId: number;
    isEnabled: boolean;
  }[];
  fields: FormFiled[];
}

export interface FormTemplate {
  id: number;
  name: string;
  modifiedAt: string;
  modifiedBy?: TeamMember;
}

export interface UpdatedFormTemplate {
  id: number;
  deletedFields: (number | string)[];
  newFields: FormFiled[];
  updatedFields: FormFiled[];
  name?: string;
  features?: {
    featureTypeId: number;
    isEnabled: boolean;
  }[];
}
